var exports = {
  "rv": "KeybindHint.module__tooltipContent___SUNqbG",
  "Pf": "KeybindHint.module__label___SUNqbG",
  "g": "KeybindHint.module__keybindHint___SUNqbG",
  "Eb": "KeybindHint.module__key___SUNqbG",
  "WK": "KeybindHint.module__keySymbol___SUNqbG" + " " + "KeybindHint.module__key___SUNqbG",
};

module.exports = exports;
